import api from '~/utils/api'

export const state = () => ({})

export const getters = {}

export const actions = {
  async requestCompanyProfile(_, params) {
    try {
      let handlerApi, handlerParams
      if (params.id) {
        handlerApi = api.directoryCompany.getCompanyPreview()
        handlerParams = { id: params.id }
      } else {
        handlerApi = api.directoryCompany.getCompanyProfile()
        handlerParams = {
          slug: params.slug,
          categorySlug: params.categorySlug
        }
      }

      const { data } = await this.$axios.get(handlerApi, {
        params: handlerParams
      })

      return data
    } catch (err) {
      throw err
    }
  },
  async requestCompanyReview(_, params) {
    try {
      // TODO Brokers Connect to Real BE
      /* eslint-disable */
      // const { data } = await this.$axios.get('', {
      //   params
      // })

      // return data

      return {
        Title: 'XM Review 2025: Platforms, Fees, Regulation, and More',
        Author: {
          Id: '',
          Name: 'Zaki Hasan',
          Slug: 'zaki-hasan',
          Status: '',
          Role: '',
          PhotoUrl: null
        },
        PublishedOn: '2025-02-09T15:06:21.623433',
        Overview: `<p>Founded in 2009, XM has emerged as a globally recognized online broker, serving over 15 million clients across 190 countries. Known for its commitment to transparency, XM offers access to a wide array of financial markets, providing traders with competitive spreads and multiple account types that cater to different trading styles.</p>
<p>Operating as a market-maker, XM directly provides liquidity to its clients, enabling fast execution with no requotes or rejections. This ensures that traders can benefit from accurate pricing and commission-free trading on most account types, while enjoying the reliability of deep liquidity pools.</p>
<p>This review will cover XM’s key features, including its trading platforms, regulation, account types, and customer support, to help you determine if this broker aligns with your trading needs.</p>`,
        OverviewImages: [],
        FeesAndSpreads: `<h2>XM Fees and Spreads</h2>
<p>XM follows a transparent fee structure, ensuring traders are fully aware of the costs involved with trading. The broker offers competitive pricing across its account types, making it an attractive choice for both beginners and seasoned traders.</p>
<p>Fees TypeXM GroupInactivity FeesYes, $10 per month after 90 days of inactivityWithdrawal Fees$0, except for bank wire transfers under $200Spread FeesVary from account types; as low as 0.6 pips on certain accountsCommission FeesNo, except for XM Zero Account, which has specific commission rates.</p>
<h3>Spreads:</h3>
<p>XM provides variable spreads starting as low as 0.6 pips for major currency pairs, such as EUR/USD, on standard accounts. For traders using the XM Zero Account, spreads can drop to 0 pips, with a small commission applied per trade. This flexibility allows traders to choose the cost structure that best aligns with their trading strategies.</p>
<h3>Commissions:</h3>
<p>Most of XM’s account types offer commission-free trading, with the broker earning revenue from the spread. The exception is the XM Zero Account, where a commission is charged in exchange for ultra-tight spreads. This model benefits high-volume traders who prioritize low trading costs.</p>
<h3>Deposit and Withdrawal Fees:</h3>
<p>XM does not charge fees for deposits or withdrawals, a key benefit for traders looking to manage costs efficiently. Additionally, XM covers all bank transfer fees for transactions over $200, ensuring that clients are not burdened with extra charges.</p>
<h3>Inactivity Fees:</h3>
<p>A $10 monthly inactivity fee is applied if an account remains dormant for more than 90 days. This fee can be avoided by ensuring regular activity in the account.
<h3>Swap Fees:</h3>
<p>Traders holding positions overnight may incur swap fees, which are clearly displayed on the trading platform. XM also offers swap-free accounts for traders who follow Islamic finance principles, ensuring compliance with Sharia law.</p>`,
        FeesAndSpreadsImages: [],
        TradingPlatforms: `<h2>XM Trading Platforms</h2>
<p>XM offers access to two of the most widely used trading platforms in the industry: MetaTrader 4 (MT4) and MetaTrader 5 (MT5). Both platforms are designed to meet the needs of traders at different experience levels, providing an array of tools and features for efficient trading.</p>
<ul><li>MetaTrader 4 (MT4): Known for its intuitive design, MT4 is ideal for forex and CFD trading. It supports automated trading through Expert Advisors (EAs) and offers comprehensive charting tools, technical indicators, and one-click trading. XM provides MT4 in various formats, including desktop, web, and mobile versions, ensuring traders can manage their accounts from any device. 
<li>MetaTrader 5 (MT5): MT5 is the upgraded version of MT4, with additional features such as more timeframes, advanced charting tools, and expanded asset coverage including stocks and futures. This platform is well-suited for traders looking to diversify their portfolio across multiple asset classes.</li></ul>
<p>Both platforms are available across desktop, web, and mobile devices, ensuring that traders can stay connected and execute trades seamlessly, no matter where they are. In addition, XM offers its own XM App, providing traders with a custom-built mobile solution for quick access to the markets.</p>`,
        TradingPlatformsImages: [],
        AccountTypes: `<h2>XM Account Types</h2>
<p>XM provides a variety of account types to accommodate traders with different needs and experience levels. Each account comes with distinct features, providing flexibility in trade sizes, costs, and market access. Traders can choose from the Standard, Ultra Low, and Shares accounts, but it’s important to note that the availability of account types depends on the XM entity under which you register. All accounts offer negative balance protection, hedging and Islamic options as standard.</p>`,
        AccountTypesImages: [],
        Scores: [
          {
            Title: 'Account Conditions',
            Value: 7.2
          },
          {
            Title: 'Tools & Resources',
            Value: 9.2
          },
          {
            Title: 'Account Conditions',
            Value: 7.2
          },
          {
            Title: 'Tools & Resources',
            Value: 9.2
          },
          {
            Title: 'Customer Service',
            Value: 9.6
          },
          {
            Title: 'Trust',
            Value: 7
          },
          {
            Title: 'Customer Service',
            Value: 9.6
          },
          {
            Title: 'Trust',
            Value: 7
          }
        ],
        Locations: [
          { Id: 212, Name: 'Ukraine', IsoCode: 'ua', CallingCode: '380' }
        ],
        Video: {
          Id: '00000000-0000-0000-0000-000000000000',
          ExternalId: '1dNYEdXWvMA',
          Hosting: 'YouTube',
          Title: 'Trading with XM: What You Need to Know',
          Description:
            'In this video, we take a closer look at XM (@xmglobal) a globally recognised online broker, serving over 15 million clients worldwide. We cover their trading model, account types, fees, and the different instruments.',
          PublishedOn: '2025-09-05T05:58:08.000Z',
          ModifiedOn: '2025-09-05T15:44:49.701Z',
          ThumbnailUrl: 'https://i.ytimg.com/vi/1dNYEdXWvMA/hqdefault.jpg'
        }
      }
    } catch (err) {
      throw err
    }
  },
  async requestRemoveCompanyPreview(_, params) {
    try {
      const { data } = await this.$axios.delete(
        api.directoryCompany.removeCompanyPreview(),
        {
          params
        }
      )
      return data
    } catch (err) {
      throw err
    }
  },
  async sendRequestToCompany(_, { captchaKey, payload }) {
    try {
      const requestSettings = {
        headers: { GoogleCaptchaResponseKey: captchaKey }
      }
      await this.$axios.post(
        api.directory.createLead(),
        payload,
        requestSettings
      )
    } catch (err) {
      throw err
    }
  },
  async checkIfForbiddenContactCompanyEmailDomain(_, { emailDomain }) {
    try {
      const forbiddenEmailDomains = JSON.parse(
        atob(this.$env.IL_FORBIDDEN_CONTACT_COMPANY_EMAIL_DOMAINS)
      )

      return forbiddenEmailDomains.includes(emailDomain)
    } catch (err) {
      return false
    }
  }
}

export const mutations = {}
